import DockMonitor from './DockMonitor';
export default DockMonitor;



// WEBPACK FOOTER //
// ../src/index.ts